
import { WebSearchStatus } from '@/types/webSearch';

export const useWebSearchProgress = () => {
  const calculateProgress = (status: WebSearchStatus | null) => {
    switch (status) {
      case 'pending': return 15;
      case 'processing': return 60;
      case 'completed': return 100;
      case 'failed': return 100;
      default: return 0;
    }
  };

  return { calculateProgress };
};
